import { FadeIn } from '@/components/motion/FadeIn';

interface Logo {
  media_id?: string;
  alt: string;
  href?: string;
}

interface Props {
  headline: string;
  logos: Logo[];
}

export function HomeTrustedBy({ headline, logos }: Props) {
  if (!logos || logos.length === 0) return null;
  return (
    <section className="border-y border-border bg-bg-subtle/30 py-12">
      <div className="container-default">
        <FadeIn>
          <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-fg-subtle">
            {headline}
          </p>
        </FadeIn>
        <FadeIn delay={0.05}>
          <div className="mt-8 grid grid-cols-2 items-center gap-8 opacity-60 sm:grid-cols-3 md:grid-cols-6">
            {logos.map((logo, idx) => {
              const content = (
                <div className="text-center text-lg font-semibold tracking-wider text-fg-muted transition-colors hover:text-gold-500">
                  {logo.alt}
                </div>
              );
              return logo.href ? (
                <a
                  key={`${logo.alt}-${idx}`}
                  href={logo.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={logo.alt}
                >
                  {content}
                </a>
              ) : (
                <div key={`${logo.alt}-${idx}`}>{content}</div>
              );
            })}
          </div>
        </FadeIn>
      </div>
    </section>
  );
}